<nb-card class="recruitment-dialog-card" style="position: relative">
  <nb-card-header class="d-flex justify-content-center align-items-center">
    <img src="assets/images/popvalet_new_logo.png" alt="">
  </nb-card-header>

  <ng-container *ngIf="form">
    <nb-card-body class="dialog-container-center" *ngIf="dialogStep === 0" [formGroup]="form">
      <div class="d-flex align-items-center flex-column">
        <h4 style="color: white; text-transform: uppercase; font-weight: bold">{{'recruitment.popup.question_eligibility' | translate}}</h4>
        <div class="container dialog-questions">
          <div class="row">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_autoentrepreneur' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="hasAutoentrepreneurStatus"
                fullWidth
                [status]="getFormControlStatus(form.controls['hasAutoentrepreneurStatus'])">
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['hasAutoentrepreneurStatus']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div *ngIf="form.controls['hasAutoentrepreneurStatus'].value === false">
            <p style="font-weight: bold; color: white">{{'recruitment.popup.auto_entrepreneur_offers_title' | translate}}</p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
          <div *ngIf="form.controls['hasAutoentrepreneurStatus'].value" class="row">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_tva' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="noTVA"
                fullWidth
                [status]="getFormControlStatus(form.controls['noTVA'])">
                <nb-option [value]="false">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="true">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['noTVA']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div *ngIf="form.controls['hasAutoentrepreneurStatus'].value" class="row">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_siret' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input formControlName="siret"
                     nbInput
                     placeholder="{{'recruitment.popup.placeholder.siret' | translate}}"
                     fullWidth
                     maxlength="14">
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['siret']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['siret']"
                  [validation]="'pattern'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_license_points' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input nbInput
                     fullWidth
                     formControlName="drivingLicensePoints"
                     type="number"
                     min="0" max="12"
                     (change)="checkLicencePoints()"
                     placeholder="{{'recruitment.popup.placeholder.driving_license_points' | translate}}">
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['drivingLicensePoints']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_license_age' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.driving_license_age' | translate}}"
                formControlName="drivingLicenseAge"
                fullWidth
                [status]="getFormControlStatus(form.controls['drivingLicenseAge'])">
                <nb-option [value]="'moreThanOrEqual5'">{{'recruitment.popup.answer_license_age_more' | translate}}</nb-option>
                <nb-option [value]="'lessThan5'">{{'recruitment.popup.answer_license_age_less' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['drivingLicenseAge']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_license_type' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.driving_license_type' | translate}}"
                formControlName="drivingLicenseType"
                fullWidth
                [status]="getFormControlStatus(form.controls['drivingLicenseType'])">
                <nb-option [value]="'european'">{{'recruitment.popup.answer_european' | translate}}</nb-option>
                <nb-option [value]="'foreign'">{{'recruitment.popup.answer_foreign' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['drivingLicenseType']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_available_on_saturday' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="availableOnSaturday"
                fullWidth
                [status]="getFormControlStatus(form.controls['availableOnSaturday'])">
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['availableOnSaturday']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_insurer' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="hasInsurer"
                fullWidth
                [status]="getFormControlStatus(form.controls['hasInsurer'])">
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false" (click)="resetFile()">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="form.controls['hasInsurer']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <ng-container [ngSwitch]="form.get('hasInsurer').value">
            <div *ngSwitchCase="true">
              <div class="row">
                <div class="col"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_insurer_info' | translate}}</p></div>
              </div>
              <div class="row">
                <button nbButton
                        status="primary"
                        class="ml-3 mb-2"
                        fullWidth
                        (click)="fileInput.click()">
                  {{'recruitment.popup.question_insurer_add_document' | translate}}
                </button>
                <input type="file"
                       class="d-none"
                       #fileInput
                       [accept]="acceptedValetFileTypes"
                       (change)="fileInputChanged($event.target.files[0])">
              </div>
            </div>
            <div *ngSwitchCase="false">
              <div class="row">
                <div class="col"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_insurer_orus_info' | translate}}</p></div>
              </div>
              <div class="row">
                <button nbButton
                        status="primary"
                        class="ml-3 mb-2"
                        fullWidth
                        (click)="redirectToOrusSubscribePage()">
                  {{'recruitment.popup.question_insurer_orus_subscribe' | translate}}
                </button>
              </div>
            </div>
          </ng-container>
          <div class="row" *ngIf="fileName">
            <div class="col"><p style="color: white; font-weight: bold">{{'recruitment.popup.question_insurer_document_added' | translate}} {{fileName}}</p></div>
          </div>
        </div>
      </div>
    </nb-card-body>

    <nb-card-body class="dialog-container-center" *ngIf="dialogStep === 1">
      <div class="d-flex align-items-center flex-column" *ngIf="eligibility === 'valid'">
        <h4 style="color: white; text-transform: uppercase; font-weight: bold">{{'recruitment.popup.question_eligibility' | translate}}</h4>
        <div class="container">
          <div class="d-flex justify-content-center align-items-center">
            <img src="assets/images/check-symbol.png" style="height: 33px">
            <p style="color: white; font-weight: bold; font-size: 18px;" class="ml-2">{{'recruitment.popup.eligibility_valid' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center flex-column" *ngIf="eligibility === 'invalid'">
        <h4 style="color: white; text-transform: uppercase; font-weight: bold">{{'recruitment.popup.question_eligibility' | translate}}</h4>
        <div class="container">
          <div class="d-flex justify-content-center align-items-center">
            <img src="assets/images/error-symbol.png" style="height: 33px" alt="error">
            <p style="color: white; font-weight: bold; font-size: 18px;" class="ml-2">{{'recruitment.popup.eligibility_invalid' | translate}}</p>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="showAutoentrepreneurCreationMessage()">
            <p style="color: white; font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_reason' | translate}}
            </p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="showEligibilityInvalidMessage()">
            <p style="color: white; font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.reasons' | translate}} :<br>
            </p>
            <p style="color: white; font-size: 16px; font-weight: 600;" class="mt-2 w-100">
              <span *ngIf="this.candidate.hasAutoentrepreneurStatus === false" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_status' | translate}}
                <br>
              </span>
              <span *ngIf="this.candidate.drivingLicensePoints < 8" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_points' | translate}}
              </span>
              <br>
              <span *ngIf="this.candidate.drivingLicenseAge === 'lessThan5'" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_age' | translate}}
              </span>
              <br>
              <span *ngIf="this.candidate.drivingLicenseType === 'foreign'" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_type' | translate}}
              </span>
            </p>
            <p style="color: white; font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_proposition' | translate}}
            </p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
        </div>
      </div>
    </nb-card-body>
  </ng-container>

  <nb-card-footer class="d-flex justify-content-center eligibility-footer-buttons">
    <button nbButton class="popup-button eligibility-create-button ml-2"
            *ngIf="dialogStep === 0"
            [disabled]="isSubmitting"
            [nbSpinner]="isSubmitting"
            (click)="updateCandidate()">{{'recruitment.popup.button_test' | translate}}</button>
    <button nbButton class="popup-button eligibility-create-button ml-2"
            *ngIf="showConnectButton && (this.dialogStep !== 1)"
            (click)="showConnexionDialog()">{{'recruitment.popup.button_connexion' | translate}}</button>

    <button nbButton class="popup-button start-recruitment"
            *ngIf="(dialogStep === 1) && (eligibility === 'valid')"
            (click)="restartRecruitmentProcess()">{{'recruitment.popup.button_recruitment_process' | translate}}</button>
    <button nbButton class="popup-button start-recruitment-mobile"
            *ngIf="(dialogStep === 1) && (eligibility === 'valid')"
            (click)="restartRecruitmentProcess()">{{'recruitment.popup.button_recruitment_process_mobile' | translate}}</button>

    <button nbButton class="popup-button"
            *ngIf="(dialogStep === 1) && (eligibility === 'invalid')"
            (click)="closeDialog()">{{'recruitment.popup.button_close_popup' | translate}}</button>
  </nb-card-footer>
</nb-card>

<ng-template #autoEntrepreneurOffers>
  <div class="auto-entrepreneur-offers-section">
    <div class="auto-entrepreneur-offer-col">
      <p style="font-weight: bold; color: white">{{'recruitment.popup.auto_entrepreneur_qonto_text' | translate}}</p>
      <button nbButton
              status="primary"
              fullWidth
              (click)="redirectToQonto()">
        {{'recruitment.popup.auto_entrepreneur_qonto_button' | translate}}
      </button>
    </div>
    <div class="auto-entrepreneur-offer-col">
      <p style="font-weight: bold; color: white">{{'recruitment.popup.auto_entrepreneur_portail_text' | translate}}</p>
      <button nbButton
              status="primary"
              fullWidth
              (click)="redirectToPortailAutoEntrepreneur()">
        {{'recruitment.popup.auto_entrepreneur_portail_button' | translate}}
      </button>
    </div>
  </div>
</ng-template>
